import React from "react";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "@audacia-hq/shared/components";

interface Props {
  fidelityPoints: number
}

const FidelityPointsBlock: React.FC<Props> = ({ fidelityPoints }) => {
  const { t } = useTranslation("member");

  return (
    <div className="bg-green-100 px-5 py-3 rounded-lg">
      <div>
        <span className="font-bold text-lg">
          <FontAwesomeIcon icon={faGift} />
          {" "}
          {t("fidelity.title")}
        </span>
        <p className="text-green-700 text-sm mt-4">
          {t("fidelity.gainFreeMinutesWithExperts")}
        </p>
        <div className="flex gap-4 items-center mt-4">
          <ProgressBar progress={fidelityPoints} />
          <div className="text-green-600 text-md font-bold whitespace-nowrap">
            {fidelityPoints}
            {" "}
            / 100
          </div>
        </div>
      </div>
    </div>
  );
};

export default FidelityPointsBlock;
